/* eslint-disable no-use-before-define */
import React from 'react'
import { ajax, Status, arrayFrom, getState, isEmpty, NO_RESULT_ICON_HTML } from '../../twd/twd'

const NO_RESULT = `
    <div class="text-center text-body">${NO_RESULT_ICON_HTML}
    <br/>
    <h4 class="small-header">No offerings available</h4>
    No offerings align with your search criteria. Please try an alternate search.
    </div>
`

export default ({rating}) => {

    const state = getState('corporates.scatter-graph')
    const [status, setStatus] = React.useState(Status.LOADING)
    const [error, setError] = React.useState('')
    const [tickersData, setTickersData] = React.useState({})

    const [top5Tickers, setTop5Tickers_] = React.useState(state.value.top5Tickers || [])
    const setTop5Tickers = React.useCallback((a) => {
        state.set({top5Tickers:a})
        setTop5Tickers_(a)
    }, [])

    const [selectedTop5Tickers, setSelectedTop5Tickers_] = React.useState(state.value.selectedTop5Tickers || [])
    const setSelectedTop5Tickers = React.useCallback((a) => {
        state.set({selectedTop5Tickers:a})
        setSelectedTop5Tickers_(a)
    }, [])

    const [customTickers, setCustomTickers_] = React.useState(state.value.customTickers || [])
    const setCustomTickers = React.useCallback((a) => {
        state.set({customTickers:a})
        setCustomTickers_(a)
        setSelectedTop5Tickers([])
    }, [])

    const [selectedCustomTickers, setSelectedCustomTickers_] = React.useState(state.value.customTickers || [])
    const setSelectedCustomTickers = React.useCallback((a) => {
        state.set({selectedCustomTickers:a})
        setSelectedCustomTickers_(a)
    }, [])

    const lastDataAbort = React.useRef()

    React.useEffect(() => {
        ;(async () => {
        try {
            setError('')
            setStatus(Status.LOADING)
            if (lastDataAbort.current) lastDataAbort.current()

            let isIG = rating === 'INVESTMENT_GRADE'
            let mktType = isIG
                ? 'CORP_IG_SCATTER_GRAPH_DATA'
                : 'CORP_HY_SCATTER_GRAPH_DATA'

            let isCustom = !isEmpty(customTickers)

            let { data, abort} = await ajax({
                url: '/esb/retailservice/yieldCurveService/getScatterGraphOfferingSearchData',
                method: 'POST',
                params: {
                    bondType: 'CORP',
                    marketSnapshotType: mktType,
                    maxYield: 20,
                    ...(isCustom ? { symbols:customTickers } : {})
                }
            })

            lastDataAbort.current = abort
            let a = ((await data).topIssuerBondsDto || {}).topBondYieldValues || {}
            lastDataAbort.current = null

            let ks = []
            let ds = {}
            for (let [k, v] of Object.entries(a)) {
                ks.push(k)
                ds[k] = arrayFrom(v)
                    .filter(i => i.yieldValue>=0.0)
                    .map(i => {
                        let r = i.scatterOfferRow
                        r.x = i.maturityYearValue
                        r.y = i.yieldValue
                        r.maturityYearValue = i.maturityYearValue
                        r.yieldValue = i.yieldValue
                        r.rating = isIG ? 'Investment Grade' : 'High Yield'
                        return r
                    })
                    .filter(a => (a.x<=30))
            }

            if (!isCustom) {
                setTop5Tickers([...ks])
                setSelectedTop5Tickers([...ks])
            } else {
                setSelectedCustomTickers([...ks])
            }

            setTickersData(ds)

            let n = Object.values(ds).reduce( (n,a) => n+a.length, 0)
            if (n===0 && isCustom) {
                setError(NO_RESULT)
                setStatus(Status.UNAVAILABLE)
                return
            }

            setStatus(Status.LOADED)

        } catch(e) {
            if (lastDataAbort.current) lastDataAbort.current()
            setStatus(Status.FAILED_TO_LOAD)
        }

        })()


        return () => {
            if (lastDataAbort.current) lastDataAbort.current()
        }

    }, [rating, customTickers])

    return {
        tickersData,
        tickersStatus: status,
        tickerError: error,

        top5Tickers,
        selectedTop5Tickers, setSelectedTop5Tickers,

        customTickers, setCustomTickers,
        selectedCustomTickers, setSelectedCustomTickers
    }
}


// WEBPACK FOOTER //
// ./src/corporates/scatter-graph/use-tickers.js